import React, { useState, useEffect, useCallback } from "react";

function Colorgame() {
  const [colors, setColors] = useState([]);
  const [target, setTarget] = useState("");
  const [message, setMessage] = useState("");

  // Generate random color
  const randomColor = () => {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgb(${r},${g},${b})`;
  };

  // Start game (wrapped in useCallback ✅)
  const startGame = useCallback(() => {
    const newColors = Array.from({ length: 6 }, () => randomColor());
    const newTarget = newColors[Math.floor(Math.random() * 6)];

    setColors(newColors);
    setTarget(newTarget);
    setMessage("");
  }, []);

  // Run only once on page load
  useEffect(() => {
    startGame();
  }, [startGame]);

  const handleGuess = (color) => {
    if (color === target) {
      setMessage("✅ Correct! You guessed it!");
    } else {
      setMessage("❌ Try again!");
    }
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-indigo-400 via-purple-400 to-pink-400 p-6">
      <div className="bg-white/70 backdrop-blur-lg p-8 rounded-2xl shadow-2xl w-full max-w-md text-center">

        <h1 className="text-3xl font-extrabold text-gray-800 mb-4">
          🎨 Color Guess Game
        </h1>

        <p className="text-lg text-gray-700 mb-4">
          Guess which color matches:{" "}
          <b className="text-blue-700">{target}</b>
        </p>

        <div className="grid grid-cols-3 gap-4 justify-center mb-4">
          {colors.map((color, index) => (
            <button
              key={index}
              onClick={() => handleGuess(color)}
              className="rounded-lg shadow-md hover:scale-110 transform transition-all duration-200 border-2 border-white"
              style={{
                backgroundColor: color,
                width: "80px",
                height: "80px",
              }}
            />
          ))}
        </div>

        <p
          className={`text-xl font-semibold mb-4 ${
            message.includes("Correct")
              ? "text-green-700"
              : "text-red-600"
          }`}
        >
          {message}
        </p>

        <button
          onClick={startGame}
          className="px-6 py-2 bg-gradient-to-r from-green-400 to-blue-500 text-white font-semibold rounded-lg shadow-lg hover:from-green-500 hover:to-blue-600 transition-all"
        >
          🔄 New Game
        </button>

      </div>
    </div>
  );
}

export default Colorgame;
